import React,{useState,useEffect,useLayoutEffect,useRef} from 'react'
import { Popover,Drawer,Button } from 'antd';
import { useHistory } from 'react-router-dom';
import { SettingOutlined,UserOutlined,LoginOutlined,LockOutlined,MenuFoldOutlined } from '@ant-design/icons';
import './header.less'
import ClickButton,{CircularButtonWithIcon} from '../link-button';
import 'flag-icon-css/css/flag-icon.min.css';
import logo from '../../assets/image/logo.png'
import {getLoginFromLocalStorage,clearLoginFromLocalStorage} from '../../pages/utils/storageUtils'

import { FormattedMessage, useIntl } from 'react-intl';

const headerTargetConfig = {
    port: {
        messageId: 'PortfolioManagementHeader',
        defaultMessage: 'Analyze asset allocation and diversification through portfolio management.',
    },
    val: {
        messageId: 'FutureAssetSimulationHeader',
        defaultMessage: 'Simulate future asset value through regular investing',
    },
    opt: {
        messageId: 'PortfolioHeader',
        defaultMessage: 'Simulate the optimal asset allocation through portfolio optimization',
    },
};

const HEADER_TARGET_MAX_WIDTH_RATIO = 2 / 3;
const HEADER_TARGET_BASE_FONT_SIZE = 16;
const HEADER_TARGET_MIN_FONT_SIZE = 7;
const HEADER_TARGET_FONT_STEP = 1;

// Matches the navigation in the mobile menu on cloudoz.jp.
const drawerSections = [
    {
        title: '試算する', titleEn: 'Calculators',
        links: [
            { label: '最適な資産配分', labelEn: 'Optimal Asset Allocation', appPath: 'opt' },
            { label: '積立と取崩計画', labelEn: 'Savings and Withdrawal Plan', appPath: 'val' },
            { label: '次に買う銘柄', labelEn: 'What to Buy Next', appPath: 'port', localized: false },
        ],
    },
    {
        title: '銘柄選定', titleEn: 'Investment Selection',
        links: [
            { label: '日本株の選定', labelEn: 'Japanese Stock Selection', href: 'https://minkabu.jp/stock/search?view=result&page=1&sort_key=dividend_yield&order=desc&minimum_purchase_price%5B0%5D=min&minimum_purchase_price%5B1%5D=max&market_capitalization%5B0%5D=3000&market_capitalization%5B1%5D=max&per%5B0%5D=min&per%5B1%5D=15&dividend_yield%5B0%5D=min&dividend_yield%5B1%5D=max&roe%5B0%5D=10&roe%5B1%5D=max' },
            { label: '日本投資信託の選定', labelEn: 'Japanese Mutual Fund Selection', href: 'https://toushin-lib.fwg.ne.jp/FdsWeb/FDST999902?r_tab=2&r_fundCategory=1&r_moneyInOutPeriodFlg=&r_sharpRaPeriodFlg=&r_returnPeriodFlg=' },
            { label: '外国投資信託の選定', labelEn: 'Foreign Fund Selection', href: 'https://etfdb.com/screener/' },
        ],
    },
    {
        title: '機能の説明', titleEn: 'How It Works',
        links: [
            { label: '最適ポートフォリオの代表銘柄', labelEn: 'Representative Assets in the Optimal Portfolio', href: 'https://cloudoz.jp/%E9%8A%98%E6%9F%84%E9%81%B8%E6%8A%9E/' },
            { label: '配当による株価調整', labelEn: 'Dividend Adjusted Stock Prices', href: 'https://cloudoz.jp/%E6%A0%AA%E4%BE%A1%E8%AA%BF%E6%95%B4/' },
            { label: 'リスクとは', labelEn: 'What Is Risk?', href: 'https://cloudoz.jp/%E5%B9%B4%E7%8E%87%E3%83%AA%E3%82%B9%E3%82%AF%E3%81%AE%E8%A8%88%E7%AE%97%E6%96%B9%E6%B3%95/' },
            { label: '年率リスクの計算方法', labelEn: 'How Annualized Risk Is Calculated', href: 'https://cloudoz.jp/%E5%B9%B4%E7%8E%87%E3%83%AA%E3%82%B9%E3%82%AF%E3%81%AE%E8%A8%88%E7%AE%97%E6%96%B9%E6%B3%95/' },
            { label: '年率リターン計算方法', labelEn: 'How Annualized Returns Are Calculated', href: 'https://cloudoz.jp/%E5%B9%B4%E7%8E%87%E3%83%AA%E3%82%BF%E3%83%BC%E3%83%B3%E8%A8%88%E7%AE%97%E6%96%B9%E6%B3%95/' },
            { label: 'ポートフォリオ最適化方法', labelEn: 'How Portfolio Optimization Works', href: 'https://cloudoz.jp/%E6%9C%80%E9%81%A9%E5%8C%96%E6%96%B9%E6%B3%95/' },
            { label: '将来の資産価値計算方法', labelEn: 'How Future Asset Values Are Calculated', href: 'https://cloudoz.jp/1027-2/' },
            { label: 'データソース', labelEn: 'Data Sources', href: 'https://cloudoz.jp/%E3%83%87%E3%83%BC%E3%82%BF%E3%82%BD%E3%83%BC%E3%82%B9/' },
        ],
    },
    {
        title: 'ブログ', titleEn: 'Blog',
        links: [
            { label: '日本株テーマ', labelEn: 'Japanese Stock Themes', href: 'https://cloudoz.jp/category/%E6%97%A5%E6%9C%AC%E6%A0%AA%E3%83%86%E3%83%BC%E3%83%9E/' },
            { label: 'ポートフォリオ最適化', labelEn: 'Portfolio Optimization', href: 'https://cloudoz.jp/category/%E3%83%9D%E3%83%BC%E3%83%88%E3%83%95%E3%82%A9%E3%83%AA%E3%82%AA%E6%9C%80%E9%81%A9%E5%8C%96/' },
            { label: '気候変動関連株', labelEn: 'Climate Change Related Stocks', href: 'https://cloudoz.jp/category/%E6%B0%97%E5%80%99%E5%A4%89%E5%8B%95%E9%96%A2%E9%80%A3%E6%A0%AA/' },
        ],
    },
];

const getHeaderTargetFromPath = (pathname = '') => {
    if (pathname.startsWith('/port')) {
        return 'port';
    }
    if (pathname.startsWith('/val')) {
        return 'val';
    }
    if (pathname.startsWith('/opt')) {
        return 'opt';
    }
    return 'opt';
};

export const Header = ({ setLocale, flagCode, pageTitle = false }) => {
    const { locale } = useIntl();
    const urlLocale = window.location.pathname.match(/\/(ja|en)\/?$/)?.[1];
    const menuLocale = urlLocale || (locale === 'en' ? 'en' : 'ja');
    const isEnglish = menuLocale === 'en';
    const [showMenu, setShowMenu] = useState(false);
    const [showTranSetting, setShowTranSetting] = useState(false);
    const [showUserSetting, setShowUserSetting] = useState(false);
    const [user, setUser] = useState(false);
    const history = useHistory();
    const targetHeaderKey = getHeaderTargetFromPath(history.location.pathname);
    const targetHeader = headerTargetConfig[targetHeaderKey];
    const headerTargetTextRef = useRef(null);
    const [headerTargetFontSize, setHeaderTargetFontSize] = useState(HEADER_TARGET_BASE_FONT_SIZE);

    useEffect(() => {
        setUser(getLoginFromLocalStorage());
    }, []);

    useLayoutEffect(() => {
        if (typeof window === 'undefined') {
            return undefined;
        }

        const headerTargetTextElement = headerTargetTextRef.current;
        const headerTargetContainer = headerTargetTextElement?.parentElement;

        if (!headerTargetTextElement || !headerTargetContainer) {
            return undefined;
        }

        const fitHeaderTargetText = () => {
            const maxViewportWidth = window.innerWidth * HEADER_TARGET_MAX_WIDTH_RATIO;
            const availableWidth = Math.min(maxViewportWidth, headerTargetContainer.clientWidth || maxViewportWidth);
            const computedStyle = window.getComputedStyle(headerTargetTextElement);
            const lineHeight = parseFloat(computedStyle.lineHeight) || (HEADER_TARGET_BASE_FONT_SIZE * 1.2);
            const allowedHeight = lineHeight;

            let nextFontSize = HEADER_TARGET_BASE_FONT_SIZE;
            headerTargetTextElement.style.fontSize = `${nextFontSize}px`;

            while (nextFontSize > HEADER_TARGET_MIN_FONT_SIZE) {
                const exceedsWidth = availableWidth > 0 && headerTargetTextElement.scrollWidth > availableWidth + 1;
                const exceedsHeight = headerTargetTextElement.scrollHeight > allowedHeight + 1;

                if (!exceedsWidth && !exceedsHeight) {
                    break;
                }

                nextFontSize -= HEADER_TARGET_FONT_STEP;
                headerTargetTextElement.style.fontSize = `${nextFontSize}px`;
            }

            setHeaderTargetFontSize((currentFontSize) => (
                currentFontSize === nextFontSize ? currentFontSize : nextFontSize
            ));
        };

        fitHeaderTargetText();

        let resizeObserver;
        if (window.ResizeObserver) {
            resizeObserver = new ResizeObserver(fitHeaderTargetText);
            resizeObserver.observe(headerTargetContainer);
        }

        window.addEventListener('resize', fitHeaderTargetText);

        return () => {
            window.removeEventListener('resize', fitHeaderTargetText);
            if (resizeObserver) {
                resizeObserver.disconnect();
            }
        };
    }, [targetHeaderKey, flagCode]);

    const accountInfoClick=()=>{
        history.push('/account');
        setShowUserSetting(!showUserSetting)
    }
    const pwdResetClick=()=>{
        let url = '/reset'
        history.push(url);
        setShowUserSetting(!showUserSetting)
    }
    
    const loginClick=()=>{
        history.push('/login');
    }
    const logoutClick=()=>{
        clearLoginFromLocalStorage()
        history.push('/login');

    }
    
    const  showUserSettingClick = () =>{
        setShowUserSetting(!showUserSetting)
     }
    const openDrawerMenu = () => setShowMenu(true);
     
     const  closeDrawerMenu = () =>{
        setShowMenu(false)
    }

    const handleHomeClick = (e) => {
        e.preventDefault();
        window.location.href = 'https://cloudoz.jp/';
    };

    const handleTranslateClick = (e) => 
    {
        setShowTranSetting(false)
        e.preventDefault();
        setLocale();
    };
    const menu = () => (
        <nav className='cloud-navigation' aria-label={isEnglish ? 'Site menu' : 'サイトメニュー'}>
            <ol className='cloud-navigation-sections'>
                {drawerSections.map((section) => (
                    <li className='cloud-navigation-section' key={section.title}>
                        <div className='cloud-navigation-heading'>【{isEnglish ? section.titleEn : section.title}】</div>
                        <ol className='cloud-navigation-links'>
                            {section.links.map((link) => (
                                <li key={link.label}>
                                    <a
                                        href={link.appPath ? `https://cloudoz.jp/${link.appPath}${link.localized === false ? '' : `/${menuLocale}`}` : link.href}
                                        target={link.appPath ? '_self' : '_blank'}
                                        rel="noopener noreferrer"
                                    >
                                        {isEnglish ? link.labelEn : link.label}
                                    </a>
                                </li>
                            ))}
                        </ol>
                    </li>
                ))}
            </ol>
        </nav>
    );
    


    return (
        <div className='header'>
        <div className='header-left' > 
        
        <img src={logo} alt="logo" style={{ height: '30px' ,marginLeft:'5px'}} onClick={handleHomeClick} />                   
        <div className={`header-title-top1 header-target-title${pageTitle ? ' header-page-target-title' : ''}`}>
            {pageTitle && <div id='page-header-title' className='header-page-title' />}
            {!pageTitle && <span
                ref={headerTargetTextRef}
                className='header-target-text'
                style={{ fontSize: `${headerTargetFontSize}px` }}
            >
                <FormattedMessage
                    id={targetHeader?.messageId || 'CompanyName'}
                    defaultMessage={targetHeader?.defaultMessage || 'CloudOz'}
                />
            </span>}
        </div>
        </div>
        <div className='header-right' >
            <div style={{display:'flex',justifyContent:'center',alignItems:'center',width:'40px'}}>
            <Popover
                title={null}
                visible={showTranSetting}
                content={<div style={{display:'flex'}} onClick={handleTranslateClick}>
                                <div className={`flag-icon flag-icon-${flagCode==='us'?'jp':'us'}`} style={{width:'24px',height:'24px'}}/>
                                <div style={{marginLeft:'5px',textDecoration: 'underline',color:'#0984e3'}}>{flagCode==='us'?'日本語':'EngLish'}</div>
                        </div>}>
                <div style={{display:'flex',justifyContent:'center',alignItems:'center'}} onClick={()=>setShowTranSetting(!showTranSetting)}>
                    <div className={`flag-icon flag-icon-${flagCode}`} style={{width:'24px',height:'24px',marginTop:'-3px' }}></div>
                </div>
            </Popover>
            </div>
            
            <div style={{display:'flex',justifyContent:'center',alignItems:'center',width:'40px'}}>
            {Object.keys(user).length !== 0 && <Popover
                    title={null}
                    visible={showUserSetting}
                    content={<div style={{display:'flex',flexDirection:'column',margin:'0px',fontSize:'12px'}}>
                                    <div>{user.FirstName}{user.SecondName}</div>
                                    <div>{user.MailAddress}</div>
                                    <div style={{height:'1px',backgroundColor:'darkgray',marginTop:'5px',marginBottom:'5px'}}></div>
                                    <div style={{fontSize:'14px',padding:'2px 0px'}}>
                                            <ClickButton onClick={()=>accountInfoClick()}><SettingOutlined  style={{paddingRight:'5px'}}/><FormattedMessage id="AccountInfo" /></ClickButton>
                                    </div>
                                    <div style={{fontSize:'14px'}}>
                                            <ClickButton onClick={()=>pwdResetClick()}><LockOutlined  style={{paddingRight:'5px'}}/><FormattedMessage id="PasswordChange" /></ClickButton>
                                    </div>
                                    <div style={{fontSize:'14px'}}>
                                            <ClickButton onClick={()=>logoutClick()}><LoginOutlined  style={{paddingRight:'5px'}}/><FormattedMessage id="Logout" /></ClickButton>
                                    </div>
                            </div>}>
                    <CircularButtonWithIcon 
                        imageUrl={user.Picture}
                        onClickHandler={showUserSettingClick}
                        txt={user.FirstName}
                    />
                </Popover>}

                {Object.keys(user).length === 0 && <Button onClick={()=>loginClick()} className='menu' >
                        <UserOutlined style={{ fontSize: '180%'}}/>
                    </Button>}
            </div>
            <div style={{display:'flex',justifyContent:'center',alignItems:'center',width:'40px'}}>
                <Button onClick={()=>openDrawerMenu()} className='menu' >
                    <MenuFoldOutlined style={{ fontSize: '180%'}}/>
                </Button>
            </div>
            
            <Drawer
                    className="cloud-navigation-drawer"
                    placement="left"
                    closable={true}
                    onClose={closeDrawerMenu}
                    visible={showMenu}
                    width={360}
                >
                {menu()}
            </Drawer>

        </div>

        </div>


    )
 }

 
